/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { BaseEndpoints } from './base.endpoints';
import { IApplication } from './api-interfaces';

export class ApplicationEndpoints extends BaseEndpoints<IApplication> {
  constructor(client: Client) {
    super(client, 'applications');
  }
}
